import React from "react";
import { TextField } from "@mui/material";
import { formatSortCode } from "../../utils/supplierBankDetails";

export default function SupplierBankFields({ value, onChange, disabled }) {
  const update = (field, next) => onChange({ ...value, [field]: next });
  return (
    <>
      <TextField
        label="Account name"
        value={value?.account_name || ""}
        disabled={disabled}
        autoComplete="off"
        onChange={(event) => update("account_name", event.target.value)}
      />
      <TextField
        label="Bank name"
        value={value?.bank_name || ""}
        disabled={disabled}
        autoComplete="off"
        onChange={(event) => update("bank_name", event.target.value)}
      />
      <TextField
        label="Sort code"
        value={value?.sort_code || ""}
        disabled={disabled}
        placeholder="12-34-56"
        autoComplete="off"
        inputProps={{ inputMode: "numeric", maxLength: 8, "aria-label": "Sort code" }}
        onChange={(event) => update("sort_code", formatSortCode(event.target.value))}
      />
      <TextField
        label="Account number"
        value={value?.account_number || ""}
        disabled={disabled}
        placeholder="12345678"
        autoComplete="off"
        inputProps={{ inputMode: "numeric", maxLength: 8, "aria-label": "Account number" }}
        onChange={(event) => update("account_number", event.target.value.replace(/\D/g, "").slice(0, 8))}
      />
    </>
  );
}
